import React, {createRef, useEffect, useState} from "react";
import classes from "./Selector.module.css";
import Users from "./Users";
import {Col, Row} from "react-bootstrap";
import classNames from "classnames";
import {KeyboardArrowDown} from "@material-ui/icons";
import {searchUserPhoto} from "../../../graph-services/GraphServices";

let Element = props => {

    let ref = createRef()
    let [proposals, setProposals] = useState([])

    useEffect(() => {
        props.allUsers.length && setProposals(props.allUsers)
    }, [props.allUsers])

    let [isOpen, setIsOpen] = useState(false)
    let [anchorEl, setAnchorEl] = useState(false)
    let [selection, setSelection] = useState(-1)

    let openProposals = (e) => {
        setIsOpen(true)
        setAnchorEl(e.currentTarget)
        setSelection(-1)
    }

    let closeProposals = () => {
        setIsOpen(false)
        setAnchorEl(null)
        setSelection(-1)
    }

    let handleChange = e => {
        props.onChange(e.target.value)
        filterProposals(e.target.value)
    }
    let addPhotos = async (users) => {

        users.forEach((El) => {
            searchUserPhoto(props.access_token, El.id)
                .then(r => {
                    if (r && r.ok) {
                        r.blob()
                            .then(photo => {
                                if (photo) {
                                    El.photo = (window.URL || window.webkitURL)
                                        .createObjectURL(photo)
                                    console.log(El.photo)
                                }
                            })
                    }
                })
        })
        return users
    }
    let lower = text => text.toLowerCase()

    function treatProposals(prefix) {
        let proposals = props.allUsers.filter(u =>
            lower(u.mail).startsWith(lower(prefix)) ||
            lower(u.displayName).startsWith(lower(prefix)) ||
            (u.givenName && lower(u.givenName).startsWith(lower(prefix))) ||
            (u.surname && lower(u.surname).startsWith(lower(prefix))))
        if (proposals.length < 10) {
            addPhotos(proposals).then(setProposals(proposals));
        } else {
            setProposals(proposals);
        }

    }

    let filterProposals = (prefix) => {
        return props.allUsers.length && treatProposals(prefix)
    }

    let confirmSelection = () => {
        closeProposals()
        props.onSelect(proposals[selection])
    }

    let scrollUp = () => {
        let _proposals = document.getElementById("_proposals")

        if (selection > 0) {
            setSelection(v => v - 1)
            _proposals && _proposals.scrollBy(0, -76)
        }
    }

    let scrollDown = () => {
        let _proposals = document.getElementById("_proposals")

        if (selection < proposals.length - 1) {
            (selection > 1) && _proposals && _proposals.scrollBy(0, 76)
            setSelection(v => v + 1)
        }
    }

    let pointOn = e => {
        // Point on by Up and Down keys & confirm by Enter key
        switch (e.keyCode) {
            // Enter
            case 13:
                e.preventDefault()
                return confirmSelection()
            // Up
            case 38:
                return scrollUp()
            // Down
            case 40:
                return scrollDown()
            default:
                return openProposals(e)
        }
    }

    let controlFeedback = props.isInvalid && <span className={classes.feedback}>{props.controlFeedback}</span>

    return <>
        <input ref={ref}
               id={"_selectorInput"}
               className={classNames(classes.input, [
                   props.disabled && classes.disabled,
                   props.isInvalid && classes.invalid
               ])}
               onClick={openProposals}
               value={props.value || ``}
               onChange={handleChange}
               onKeyDown={pointOn}
               disabled={props.disabled}
               spellCheck={false}
               autoComplete={"off"}
        />
        <KeyboardArrowDown className={classes.icon}/>
        {controlFeedback}
        <Row>
            <Col sm={"3"}/>
            <Col sm={"9"}>
                <Users proposals={proposals}
                       open={isOpen}
                       anchorEl={anchorEl}
                       onClose={closeProposals}
                       onSelect={props.onSelect}
                       selection={selection}
                       lang={props.lang}
                />
            </Col>
        </Row>
    </>
}

export default Element